import { http, passthrough } from 'msw';

const API_PREFIX = '/api/';

// The browser worker applies the same rule in the patched mockServiceWorker.js.
export const passthroughNonApiHandler = http.all('*', ({ request }) => {
  const { pathname } = new URL(request.url);

  if (!pathname.startsWith(API_PREFIX)) {
    return passthrough();
  }

  return;
});
